/* eslint-disable */
import { request } from 'request';
import { responseWait, responseEnd } from '../actions/common/loadingActions';

const reducer = (state = {}, action) => {
  switch (action.type) {
    case 'LOAD':
      return {
        data: action.data,
      };
    default:
      return state;
  }
};

/**
 * Simulates data loaded into this reducer from somewhere
 */
export const load = () => (dispatch) => {
  /* request goes here */

  //   dispatch(responseWait());
  //   const opts = {};

  //   request(opts, (err, res, body) => {
  //     if (err) {
  //     } else if (res.statusCode === 200) {
  //     disptach({ type: 'LOAD', data: body.data });
  //     dispatch(responseEnd());
  //   }
  // });

  // ejemplo nomas
  dispatch({
    type: 'LOAD',
    data: {
      firstName: 'Jane',
      lastName: 'Doe',
      email: 'hola@gmail.com',
      password: 'Doe',
      password2: 'Doe',
    },
  });
};

export default reducer;
